<!-- 预付款申请数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
            :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index == 0">
                <!-- 主要信息 -->
                <div>
                  <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                    size="mini" :show-message="false">
                    <el-row slot="" v-if="dataActionBox.actionType != 2">
                      <el-form-item label="账簿编号" prop="abookCode"
                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <label slot="label" :style="$common.labelStyle('账簿编号')"
                          v-html="$common.htmlLabel('账簿编号')"></label>
                        <el-input v-model="sendDataInfo.abookCode" class="form_codition"></el-input>
                      </el-form-item>
                      <el-form-item label="账簿名称" prop="abookName"
                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <label slot="label" :style="$common.labelStyle('账簿名称')"
                          v-html="$common.htmlLabel('账簿名称')"></label>
                        <el-input v-model="sendDataInfo.abookName" class="form_codition"></el-input>
                      </el-form-item>
                      <el-form-item label="账簿金额" prop="abookAccount"
                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <label slot="label" :style="$common.labelStyle('账簿金额')"
                          v-html="$common.htmlLabel('账簿金额')"></label>
                        <el-input v-model="sendDataInfo.abookAccount" type="number" class="form_codition"></el-input>
                      </el-form-item>
                      <el-form-item label="是否承兑" prop="isHonour">
                        <label slot="label" :style="$common.labelStyle('是否承兑')"
                          v-html="$common.htmlLabel('是否承兑')"></label>
                        <el-select v-model="sendDataInfo.isHonour" placeholder="请选择" class="form_codition">
                          <el-option label="否" :value="0"></el-option>
                          <el-option label="是" :value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="账簿类型" prop="abookType">
                        <label slot="label" :style="$common.labelStyle('账簿类型')"
                          v-html="$common.htmlLabel('账簿类型')"></label>
                        <el-select v-model="sendDataInfo.abookType" placeholder="请选择" class="form_codition">
                          <el-option label="对公" :value="0"></el-option>
                          <el-option label="对私" :value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否管理余额" prop="isDock">
                        <label slot="label" :style="$common.labelStyle('是否管理余额')"
                          v-html="$common.htmlLabel('是否管理余额')"></label>
                        <el-select v-model="sendDataInfo.isDock" placeholder="请选择" class="form_codition">
                          <el-option label="否" :value="0"></el-option>
                          <el-option label="是" :value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="账簿用途" prop="purpose">
                        <label slot="label" :style="$common.labelStyle('账簿用途')"
                          v-html="$common.htmlLabel('账簿用途')"></label>
                        <el-select v-model="sendDataInfo.purpose" placeholder="请选择" class="form_codition">
                          <el-option label="结算" :value="1"></el-option>
                          <el-option label="零售" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="零售付款方式" prop="payType">
                        <label slot="label" :style="$common.labelStyle('零售付款方式')"
                          v-html="$common.htmlLabel('零售付款方式')"></label>
                        <el-select v-model="sendDataInfo.payType" placeholder="请选择" class="form_codition">
                          <el-option label="其他" :value="0"></el-option>
                          <el-option label="现金" :value="1"></el-option>
                          <el-option label="会员" :value="2"></el-option>
                          <el-option label="微信" :value="3"></el-option>
                          <el-option label="支付宝" :value="4"></el-option>
                          <el-option label="医保" :value="5"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-row>
                    <el-row slot="" v-if="dataActionBox.actionType != 2" id="elRow">
                      <el-form-item label="零售付款配置" prop="payConfigJson" style="width: 100%;">
                        <label slot="label" :style="$common.labelStyle('零售付款配置')"
                          v-html="$common.htmlLabel('零售付款配置')"></label>
                        <el-input type="textarea" style="width: 100%;" :rows="2" placeholder="请输入零售付款配置"
                          v-model="sendDataInfo.payConfigJson">
                        </el-input>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foots">
          <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
            @click="showPrintPlan">打印
          </el-button>
          <el-button type="primary" @click="initActionBox('sendDataInfo')"
            v-if="dataActionBox.actionType != 2">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 1">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "accountBooksManagerAction",
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        "abookAccount": 0,
        "abookCode": "",
        "abookId": 0,
        "abookName": "",
        "isHonour": 0,
        "abookType": 0,
        "isDock": 1,
        "purpose": 1,
        "payType": 0,
        "payConfigJson": "",
      },
      showTabs: "账簿信息",
      tabForm: [
        {
          jciName: "账簿信息",
          jurconfigform: []
        }
      ],
      mxHeight: 0,
      mxForm: [],
      footForm: [],
      formDataList: [],
      userOneList: [],
      seId: "",
      seWidth: "",
      height: "",
      seTitle: "",
      seWidth: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      parentSearchData: {
        smId: "",
      },
      tables: false,

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
          this.inputel[index].focus()
          break
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) return
      var aindex = index + 1
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
          .printJurId)
      } else {
        return
      }
    },
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    //检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },

    initActionBox(sendDataInfo) {
      this.dataActionBox.actionType = 0;
      this.$emit('drawerCancel')
      this.tables = false;
      this.init();
      this.$refs[sendDataInfo].resetFields();
    },
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.sendDataInfo.isDefault = 0;
      this.sendDataInfo.isHonour = 0;
      this.sendDataInfo.abookType = 0;
      this.sendDataInfo.abookAccount = 0;
      this.sendDataInfo.isDock = 1;
      this.sendDataInfo.purpose = 1;
      this.sendDataInfo.payType = 0;
      this.sendDataInfo.payConfigJson = "";
    },


    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      var oldData = this.actionData.oldData
      this.init();
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        for (let key in oldData) {
          this.sendDataInfo[key] = oldData[key];
        }
      } else {
        this.tables = true
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
      }
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          return this.$message({
            message: "请完善必填信息",
            type: "error",
          });
        }
      });
    },
    async sub() {
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      if (this.dataActionBox.actionType == 0) {
        // 新增账簿
        var responseData = await this.$http.addAccountbook(sendData);
      } else {
        // 修改账簿
        var responseData = await this.$http.updateAccountbook(sendData);
      }
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit('drawerCancel', true)
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.mb {
  margin-bottom: 0;
}

.newInput {
  height: 28px;
  line-height: 28px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
::v-deep #mainInfo #elRow .el-form-item__content{
  width: calc(100% - 100px) !important;
}
::v-deep #mainInfo #elRow .el-textarea__inner, ::v-deep #mainInfo #elRow .el-date-editor.el-input{
  width: 100% !important;
}
</style>